<template lang="pug">
.crud(v-shortcuts="[{ shortcut: [ 'c', ], callback: addRecord, push: true, focus: true },{ shortcut: [ 'e', ], callback: editShortcut, push: true, focus: true },{ shortcut: [ 'f', ], callback: setFocusSearch, push: true, focus: true },]")
  modal-import(model="requisitions_mailboxes")
  modal-requisitions-mailboxes(:form='form', :is-add='isModalAdd')
  modal-summary-order(:form="form")
  .container-fluid
    vm-tabs(v-model='tap')
      vm-tab(vm-label="Buzón de requisiciones" vm-alignment="fixed" class="tab")
        mailboxes-view
      vm-tab(vm-label="Ordenes de compra" vm-alignment="fixed" class="tab")
        purcharse-orders-view(@odDetails="odDetails")
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('RequisitionsMailboxes')
const ModalImport = () => import('@/components/modals/ModalImport.vue')
const ModalRequisitionsMailboxes = () => import('@/components/modals/ModalRequisitionsMailboxes.vue')
const MailboxesView = () => import('@/components/tabs/MailboxesView.vue')
const PurcharseOrdersView = () => import('@/components/tabs/PurcharseOrdersView.vue')
const ModalSummaryOrder = () => import('@/components/modals/ModalSummaryOrder.vue')

export default {
  name: 'RequisitionsMailboxes',
  components: {
    ModalImport,
    ModalRequisitionsMailboxes,
    MailboxesView,
    PurcharseOrdersView,
    ModalSummaryOrder
  },
  data: () => ({
    currentPage: 1,
    form: {}
  }),
  computed: {
    ...mapGetters([])
  },
  methods: {
    ...mapActions([
      'setModalSummaryVisible'
    ]),
    odDetails (record) {
      this.form = record
      this.setModalSummaryVisible(true)
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1) {
    width: 100%;
  }
  .input-select-con {
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    .vm-button {
      background-color: white !important;
      color: #929292;
      padding: 0 !important;
      width: 30px;
      height: 30px;
    }
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}
</style>
